import React, { Fragment } from "react";
import FilePicker from "components/FilePicker";
import get from "lodash/get";
import { useFormikContext } from "formik";
import { getFieldPath } from "utils/form";
import {
  PICKER_OPTIONS,
  PROMPTS,
  ATTACHMENT_CONTEXT_TYPE
} from "utils/constants/attachment";
import {
  attachmentSizeLabel,
  formatUploadedAttachment
} from "utils/attachment";
import ConnectedTextarea from "components/ConnectedTextarea";

const FileField = ({ name, context = ATTACHMENT_CONTEXT_TYPE.CONTENT }) => {
  const {
    values,
    touched,
    setFieldTouched,
    setFieldValue
  } = useFormikContext();
  const attachment = get(values, name);
  const fileUrlPath = getFieldPath(name, "data.url");
  const filenamePath = getFieldPath(name, "data.filename");
  const sizePath = getFieldPath(name, "data.size");
  const mimetypePath = getFieldPath(name, "data.mimetype");
  const src = get(values, fileUrlPath);
  const mimetype = get(values, mimetypePath);
  const size = get(values, sizePath);
  const filename = get(values, filenamePath);

  let nodes = [];
  if (src) {
    nodes = [
      <ConnectedTextarea name={filenamePath} label="Name" minRows={1} />,
      <ConnectedTextarea
        name={mimetypePath}
        label="Type"
        minRows={1}
        disabled
      />,
      <ConnectedTextarea
        name={sizePath}
        value={attachmentSizeLabel(size)}
        label="Size"
        minRows={1}
        disabled
      />
    ];
  }

  return (
    <Fragment>
      <FilePicker
        pickerOptions={PICKER_OPTIONS.FILES}
        prompts={PROMPTS.FILES}
        icon="upload"
        mimetype={mimetype}
        size={size}
        src={src}
        filename={filename}
        onPickerDone={(files) => {
          const updatedAttachment = formatUploadedAttachment({
            attachment,
            context,
            file: files[0]
          });

          setFieldValue(name, updatedAttachment);
          const isTouched = get(touched, fileUrlPath);
          if (!isTouched) {
            setFieldTouched(fileUrlPath, true);
          }
        }}
      />
      {nodes.map((node, nodeIx) => (
        <div key={nodeIx} className={`w-100 ${nodeIx ? "pt3" : ""}`}>
          {node}
        </div>
      ))}
    </Fragment>
  );
};

export default FileField;
